<template>
  <div id="app">
    {{ stateSync }}
    <div>
      <router-view />
    </div>
    <Internet />
  </div>
</template>

<script>
import Internet from "./components/fixedcomponents/Internet.vue";
import { refreshAccessToken } from "./utils/request";
import {
  startTokenExpiryWatcher,
  checkExternalPanelist,
} from "./utils/tokenCheck";
import { checkAccess } from "./permission";
export default {
  name: "CreateJobs",
  components: {
    Internet,
  },
  data() {
    return {
      mini: true,
    };
  },
  // Save data on reload
  computed: {
    stateSync() {
      let stt = this.$store.state;
      localStorage.setItem("simpAdminState", JSON.stringify(stt));
      return "";
    },
  },
  created() {
    let savedstate = localStorage.getItem("simpAdminState");
    if (savedstate != null) {
      this.$store.replaceState(JSON.parse(savedstate));
    }
    if (!checkExternalPanelist() && checkAccess()) {
      refreshAccessToken();
    }
    startTokenExpiryWatcher();
  },
};
</script>
<style>
::placeholder {
  font-weight: 400;
  font-size: 13px;
  color: #6d6d6d;
  opacity: 0.4;
}
body {
  font-family: "Poppins", sans-serif;
}
</style>
<style lang="scss">
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
